module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "users"
  }, [_vm._m(0), _vm._v(" "), (!_vm.usersList) ? _c('div', {
    staticClass: "loading-holder"
  }, [_c('h3', [_vm._v("Loading Data...")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-progress mdl-js-progress mdl-progress__indeterminate"
  }), _vm._v(" "), _c('h4', [_vm._v("Please wait!")])]) : _vm._e(), _vm._v(" "), (_vm.usersList) ? _c('div', {
    staticClass: "users-card mdl-card mdl-shadow--2dp",
    class: {
      blurred: _vm.state == 'working'
    }
  }, [_c('div', {
    staticClass: "mdl-card__supporting-text search"
  }, [_c('i', {
    staticClass: "material-icons searchIcon"
  }, [_vm._v("search")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "search"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "search"
    }
  }, [_vm._v("Search...")])])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand"
  }, [_c('div', {
    staticClass: "users-list"
  }, _vm._l((_vm.filteredUsersList), function(user) {
    return _c('div', [_c('router-link', {
      attrs: {
        "to": {
          name: 'user',
          params: {
            userId: user.id
          }
        }
      }
    }, [_c('i', {
      staticClass: "material-icons user-icon"
    }, [_vm._v("person")]), _vm._v(" "), _c('span', {
      staticClass: "user-name"
    }, [_vm._v(_vm._s(user.display))])])], 1)
  }))]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__actions mdl-card--border"
  }, [_c('button', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    on: {
      "click": _vm.addUser
    }
  }, [_vm._v("\n        Add empty user\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    on: {
      "click": _vm.openAddEmailPasswordDialog
    }
  }, [_vm._v("\n        Add user with email and password\n      ")])])]) : _vm._e(), _vm._v(" "), (_vm.addEmailPasswordDialog) ? _c('div', {
    staticClass: "dialog-holder"
  }, [_c('div', {
    staticClass: "dialog mdl-card mdl-shadow--4dp"
  }, [_c('div', {
    staticClass: "mdl-card__title mdl-color--accent"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v("Change password")]), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent",
    on: {
      "click": function () { return _vm.addEmailPasswordDialog = false; }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("close")])])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand"
  }, [_c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield&#45;&#45;floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newEmail),
      expression: "newEmail"
    }],
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "email",
      "id": "email"
    },
    domProps: {
      "value": (_vm.newEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newEmail = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("New email")])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield&#45;&#45;floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword),
      expression: "newPassword"
    }],
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "pass2"
    },
    domProps: {
      "value": (_vm.newPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "pass2"
    }
  }, [_vm._v("New password")])])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__actions mdl-card--border",
    class: {
      blurred: _vm.state == 'saving'
    }
  }, [_c('a', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    on: {
      "click": function () { return _vm.addEmailPasswordDialog = false; }
    }
  }, [_vm._v("\n          Cancel\n        ")]), _vm._v(" "), _c('a', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    on: {
      "click": _vm.addEmailPassword
    }
  }, [_vm._v("\n          Add email/password\n        ")])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "demo-header mdl-layout__header mdl-color--grey-100 mdl-color-text--grey-600"
  }, [_c('div', {
    staticClass: "mdl-layout__header-row"
  }, [_c('span', {
    staticClass: "mdl-layout-title"
  }, [_vm._v("Users")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-layout-spacer"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6be28c48","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Users.vue
// module id = 421
// module chunks = 1